import apps_id_shield from './apps-id-shield.svg';
import apps_legal_shield from './apps-legal-shield.svg';

export const V2_APPS_ICONS: { [char: string]: string } = {
  apps_id_shield,
  apps_legal_shield,
};

export const V2_APPS_ICON_NAMES: string[] = Object.keys(V2_APPS_ICONS);
